import Report from "../components/message/report";

export default Report